import React, { useState, useEffect } from "react";
import MainMenu from "../../Header/NavMenu/MainMenu";
import MobileNavigation from "../../Header/NavMenu/MobMenu/MobileNavigation";

function Menu(Menu) {
  const [isMobileResponsive, setIsMobileResponsive] = useState(false);
  const handleResize = () => {
    if (window.innerWidth <= 989) {
      setIsMobileResponsive(true);
    } else {
      setIsMobileResponsive(false);
    }
  };
  useEffect(() => {
    handleResize();
    window.addEventListener("resize", handleResize);
  });
  if (typeof Menu.menuItems != "undefined") {
    if (isMobileResponsive) {
      return <MobileNavigation menuItems={Menu.menuItems} />;
    } else {
      return <MainMenu menuItems={Menu.menuItems} />;
    }
  } else {
    return (
      <>
        <h2>Enter menu items</h2>
      </>
    );
  }
}

export default Menu;
